import type { Size } from "../types";

export const baseApi = window.location.host.includes(`localhost`)
    ? `https://localhost:8443/api/`
    : window.location.host.includes(`stage`)
      ? `https://mall-stage-api.loyaltyinnovation.com/api/`
      : window.location.host.includes(`develop`)
        ? `https://mall-develop-api.loyaltyinnovation.com/api/`
        : `https://mall-api.loyaltyinnovation.com/api/`;

export const GoogleApiKey = `AIzaSyDzu-1Qu_l7PmCrUTQM56pC6_5wYEla4s4`;

export const sizes: [number, number, Size][] = [
    [0, 767, `small`],
    [768, 992, `medium`],
    [993, 999999, `large`],
];

export const logoBoxSizes = {
    large: { w: 250, h: 166 },
    medium: { w: 250, h: 166 },
    small: { w: 160, h: 166 },
};

export const popMargins = {
    large: 20,
    medium: 20,
    small: 10,
};

export const iconSizes = {
    large: 170,
    medium: 170,
    small: 170,
};

export const iconMinMargins = {
    large: 10,
    medium: 10,
    small: 8,
};

export const TOPBARHEIGHT = 80;
export const MAX_USABLE_DISPLAY_WIDTH = 1440;
